export const warehouseQueryKeys = {
  id: 'id',
  name: 'warehouse_name',
  code: 'warehouse_code',
  isMain: 'is_main',
  description: 'descr',
  departmentId: 'department_id',
  departmentName: 'department_name',
  departmentCode: 'department_code',
  address: 'address',
  stateId: 'state_id',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
}
